import customTheme from "../../../theme";
const SecurityStyles = {
    container: {
      position: "relative",
      display: "inline-block",
    },
    dropdownWrapper: {
      position: "absolute",
      top: -5,
      left: "100%", // justo al lado derecho
      marginLeft: 8,
      zIndex: 100,
    },
    triangleOuter: {
      position: "absolute",
      top: "50%",
      left: -7,
      transform: "translateY(-50%)",
      width: 0,
      height: 0,
      borderTop: "7px solid transparent",
      borderBottom: "7px solid transparent",
      borderRight: "7px solid #ccc", // sin sombra aquí
      zIndex: 101,
    },
    triangleInner: {
      position: "absolute",
      top: "50%",
      left: -6,
      transform: "translateY(-50%)",
      width: 0,
      height: 0,
      borderTop: "6px solid transparent",
      borderBottom: "6px solid transparent",
      borderRight: "6px solid #f4f4f6", // mismo color que el fondo
      zIndex: 102,
    },
    dropdownBox: {
      display: "flex",
      backgroundColor: "#f4f4f6",
      border: "1px solid #ccc",
      padding: "4px 9px",
      borderRadius: "4px",
      boxShadow: "none", // quitar sombra si deseas total limpieza
    },
    button: {
      all: "unset",
      cursor: "pointer",
      fontSize: "18px",
    },
    btnContinue: {
      backgroundColor: customTheme.palette.primary.main,
      "&:hover": {
        backgroundColor: customTheme.palette.primary.dark,
      },
    },
  };

  export default SecurityStyles;